import { CloseIcon } from '../../icons/CloseIcon';
import { Divider, DismissButton, IconWrapper, NoteText, Wrapper } from './InfoNote.styles';
import type { InfoNoteProps } from './InfoNote.types';

export function InfoNote({
  text,
  icon,
  variant = 'neutral',
  onDismiss,
  dismissLabel = 'Dismiss',
}: InfoNoteProps) {
  return (
    <Wrapper $variant={variant}>
      {icon && <IconWrapper $variant={variant}>{icon}</IconWrapper>}
      <NoteText $variant={variant}>{text}</NoteText>
      {onDismiss && (
        <>
          <Divider $variant={variant} />
          <DismissButton
            type="button"
            onClick={onDismiss}
            aria-label={dismissLabel}
            $variant={variant}
          >
            <CloseIcon size={12} />
          </DismissButton>
        </>
      )}
    </Wrapper>
  );
}
